{
  "alert.informative": "Informativ",
  "alert.negative": "Negativ",
  "alert.notice": "Meddelande",
  "alert.positive": "Positiv",
  "attachmentlist.nextAttachments": "Visa nästföljande bilagor",
  "attachmentlist.previousAttachments": "Visa tidigare bilagor",
  "chat.newMessage": "Nytt meddelande",
  "chat.scrollToBottom": "Bläddra till slutet",
  "messagefeedback.thumbDown": "Dåligt svar",
  "messagefeedback.thumbUp": "Bra svar",
  "promptfield.aiDisclaimer": "Svar genereras med hjälp av AI och kan vara felaktiga. Kontrollera dem före användning.",
  "promptfield.aiUserGuidlines": "Användarriktlinjer för AI",
  "promptfield.attachments": "Bilagor",
  "promptfield.insertButton": "Lägg till",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Redo att komma igång? Ställ en fråga, dela en idé eller lägg till en uppgift.",
  "promptfield.placeholder.small": "Fråga vad som helst",
  "promptfield.stopButton": "Avbryt",
  "promptfield.submitButton": "Skicka",
  "promptfield.uploading": "Laddar upp",
  "responsestatus.loading": "Läser in",
  "responsestatus.processing": "Bearbetar ...",
  "voicebutton.startListening": "Starta inspelning",
  "voicebutton.stopListening": "Stoppa inspelningen"
}
